/* eslint react/no-unused-prop-types: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import Auth from '@aws-amplify/auth';
import clone from 'clone';
import {
  Button,
  Checkbox,
  Container,
  Divider,
  Grid,
  Header,
  Progress,
  Label,
  Segment,
} from 'semantic-ui-react';
import _ from 'lodash';
import queryString from 'query-string';
import { fetchM } from '../../actions/fetchM';
import { push } from 'react-router-redux';

import LoanInfo from './LoanInfo';
import IncomeForm from './NewIncomeForm';
import PersonalInfo from './PersonalInfo';
import UploadForm from './UploadForm';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { bookingFlow } from '../../utils/routes';

class NewCreditCheck extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      company: PropTypes.object,
    }),
    bookingID: PropTypes.string,
    customerID: PropTypes.string.isRequired,
    customerCreditReportID: PropTypes.string,
    customerCreditReport: PropTypes.shape({
      consentDsrDocumentID: PropTypes.string,
      consentDsrDocument: PropTypes.object,
    }),
    customerCreditReports: PropTypes.arrayOf(
      PropTypes.object,
    ),
    data: PropTypes.shape({
      id: PropTypes.string,
    }),
    icFrontDocumentID: PropTypes.string,
    icFrontDocument: PropTypes.shape({
      key: PropTypes.string,
      tags: PropTypes.arrayOf(
        PropTypes.string,
      ),
    }),
    icBackDocumentID: PropTypes.string,
    icBackDocument: PropTypes.shape({
      key: PropTypes.string,
      tags: PropTypes.arrayOf(
        PropTypes.string,
      ),
    }),
    identityTypeID: PropTypes.number,
    identity: PropTypes.string,
    incomeID: PropTypes.string,
    income: PropTypes.shape({
      id: PropTypes.string,
      isEmployed: PropTypes.bool,
    }),
    loading: PropTypes.bool,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
      hash: PropTypes.string,
    }),
    onChange: PropTypes.func,
    setLoading: PropTypes.func,
    refetch: PropTypes.func,
    routeParams: PropTypes.shape({
      bookingID: PropTypes.string,
    }),
    params: PropTypes.shape({
      id: PropTypes.string,
      customerID: PropTypes.string,
    }),
    pathCheck: PropTypes.bool,
    newHeader: PropTypes.string,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultProps = {
    customerCreditReport: null,
    customerCreditReportID: '',
    data: [],
    icFrontDocumentID: '',
    icFrontDocument: null,
    icBackDocumentID: '',
    icBackDocument: null,
    incomeID: '',
    income: null,
    isAgreedToDSRTerms: false,
  }
  static getPropsToState = (props) => {
    const customerCreditReportID = props.customerCreditReportID;
    const customerCreditReport = props.customerCreditReport;
    const customerCreditReports = props.customerCreditReports;
    const customerDetail = props.customerDetail;
    const data = props.data;
    const icFrontDocumentID = props.icFrontDocumentID;
    const icFrontDocument = props.icFrontDocument;
    const icBackDocumentID = props.icBackDocumentID;
    const icBackDocument = props.icBackDocument;
    const incomeID = props.incomeID;
    const income = props.income;
    return {
      customerCreditReportID,
      customerCreditReport,
      customerCreditReports,
      customerDetail,
      data,
      icFrontDocumentID,
      icFrontDocument,
      icBackDocumentID,
      icBackDocument,
      incomeID,
      income,
      oriCustomerCreditReport: clone(customerCreditReport),
      oriData: clone(data),
      oriIcFrontDocument: clone(icFrontDocument),
      oriIcBackDocument: clone(icBackDocument),
      oriIncome: clone(income),
    };
  }
  constructor(props) {
    super(props);
    const state = NewCreditCheck.getPropsToState(props);
    const customerCreditReports = state.customerCreditReports;
    let currentStep = 0;
    if (props.location && props.location.hash.length > 0) {
      const currentTab = props.location.hash.replace('#', '');
      switch (currentTab) {
        case 'new':
          currentStep = 0;
          break;
        case 'document':
          currentStep = 1;
          break;
        case 'identity':
          currentStep = 2;
          break;
        case 'income':
          currentStep = 3;
          break;
        default:
          currentStep = 0;
      }
    }
    this.state = {
      ...state,
      currentStep,
      customerCreditReports,
      bookingData: [],
      consentForm: null,
      creditCheckReportData: [],
      customerCreditReport: state.customerCreditReport || null,
      custToken: null,
      documentToken: null,
      headerContent: '',
      icFront: null,
      icBack: null,
      incomeToken: null,
      progressPercent: 0,
      reportToken: null,
      isSigned: false,
    };
  }
  componentDidMount() {
    if (this.props.pathCheck) {
      this.fetchBooking();
    }
    if (location.search !== '') {
      const values = queryString.parse(this.props.location.search);
      if (values.currentStep !== '') {
        this.fetchBookingCustomer();
        this.setState({ currentStep: _.toNumber(values.currentStep) });
      }
    }
    this.fetchCustomerCreditReport();
  }
  componentWillReceiveProps(nextProps) {
    const state = NewCreditCheck.getPropsToState(nextProps);
    if (this.checkStringify(state.oriData, this.state.oriData)) {
      state.data = this.state.data;
    }
    if (this.checkStringify(state.oriCustomerCreditReport, this.state.oriCustomerCreditReport)) {
      state.customerCreditReport = this.state.customerCreditReport;
    }
    if (this.checkStringify(state.oriIcFrontDocument, this.state.oriIcFrontDocument)) {
      state.icFrontDocument = this.state.icFrontDocument;
    }
    if (this.checkStringify(state.oriIcBackDocument, this.state.oriIcBackDocument)) {
      state.icBackDocument = this.state.icBackDocument;
    }
    if (this.checkStringify(state.oriIncome, this.state.oriIncome)) {
      state.income = this.state.income;
    }
    state.customerCreditReports = this.state.customerCreditReports;
    this.setState({
      ...state,
    });
  }
  setLoading = (loading = false, callback) => {
    if (this.props.setLoading) {
      return this.props.setLoading(loading);
    }
    if (callback) {
      callback();
    }
    return Promise.resolve();
  }
  getCreditCheckToken(callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/customers/${this.props.customerID}/credit_reports/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then((res) => {
        const reportToken = res.headers.get('X-Csrf-Token');
        this.setState({
          reportToken,
        }, () => {
          if (callback) {
            callback();
          }
        });
      });
  }
  getCustToken(callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/customers/${this.props.customerID}/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
    .catch((err) => {
      store.dispatch(flashErrorMessage(err));
    })
    .then((res) => {
      const custToken = res.headers.get('X-Csrf-Token');
      this.setState({
        custToken,
      }, () => {
        if (callback) {
          callback();
        }
      });
    });
  }
  getDocumentToken(callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/customers/${this.props.customerID}/documents/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
    .catch((err) => {
      store.dispatch(flashErrorMessage(err));
    })
    .then((res) => {
      const documentToken = res.headers.get('X-Csrf-Token');
      this.setState({
        documentToken,
      }, () => {
        if (callback) {
          callback();
        }
      });
    });
  }
  getIncomeToken(callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/customers/${this.props.customerID}/income/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then((res) => {
        const incomeToken = res.headers.get('X-Csrf-Token');
        this.setState({
          incomeToken,
        }, () => {
          if (callback) {
            callback();
          }
        });
      });
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  setSignedState = () => {
    this.setState({ isSigned: true });
  }
  checkNextDisabled = () => {
    const {
      consentForm, currentStep, customerCreditReport, data, incomeID,
      icFront, icBack, income,
      icFrontDocumentID, icBackDocumentID, isAgreedToDSRTerms, isSigned,
    } = this.state;
    const hasCustInfo = data.customerDetail.name !== '' && data.customerDetail.mobilePrefix !== '' && data.customerDetail.mobile !== '';
    const hasConsentID = customerCreditReport && customerCreditReport !== null &&
          customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' &&
          customerCreditReport.consentDsrDocumentID !== null &&
          customerCreditReport.consentDsrDocumentID.length > 0;
    const hasIcFrontID = icFrontDocumentID.length > 0;
    const hasIcBackID = icBackDocumentID.length > 0;
    const hasIncomeID = incomeID.length > 0;
    const hasIcFront = icFront !== null && icFront.file !== null;
    const hasIcBack = icBack !== null && icBack.file !== null;
    const hasIncome = income && ((income.netIncome !== '' && income.netIncome > 0));
    const hasConsentForm = (customerCreditReport && customerCreditReport.consentDsrDocumentID !== '' && customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' && isSigned) || consentForm !== null || isSigned;

    switch (currentStep) {
      case 0:
        return !(hasCustInfo);
      case 1:
        return !(hasConsentForm);
      case 2:
        return !((hasIcFrontID && hasIcBackID) || (hasIcFront && hasIcBackID) || (hasIcFrontID && hasIcBack) || (hasIcFront && hasIcBack));
      case 3:
        return !(hasIncome);
      case 4:
        return !(hasConsentID && hasIncomeID && hasIcFrontID && hasIcBackID && isAgreedToDSRTerms);
      default:
        return false;
    }
  }
  checkStepContent = (currentStep = 0, checkID = false, checkForm = false, defaultCheck) => {
    const {
      consentForm, customerCreditReport, data, icFront, icBack,
      icFrontDocumentID, icBackDocumentID, income, incomeID,
      isEmployed,
    } = this.state;
    if (checkForm) {
      this.fetchCustomer();
    }
    const hasCustInfo = data.customerDetail.name !== '' && data.customerDetail.mobilePrefix !== '' && data.customerDetail.mobile !== '';
    const hasConsentID = customerCreditReport && customerCreditReport !== null &&
          customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' &&
          customerCreditReport.consentDsrDocumentID !== '' &&
          customerCreditReport.consentDsrDocumentID.length > 0;
    const hasIcFrontID = icFrontDocumentID.length > 0;
    const hasIcBackID = icBackDocumentID.length > 0;
    const hasIncomeID = incomeID.length > 0;

    // upload form
    const hasConsentForm = consentForm && consentForm.src && consentForm.src.length > 0;
    const hasIcFront = icFront && icFront.src && icFront.src.length > 0;
    const hasIcBack = icBack && icBack.src && icBack.src.length > 0;
    const hasIncome = income && ((income.netIncome !== '' || income.netIncome > 0) ||
    (!isEmployed && (income.basicIncome !== '' || income.basicIncome > 0)));

    switch (currentStep) {
      case 0:
        return hasCustInfo;
      case 1:
        if (checkID) {
          return hasConsentID;
        }
        if (checkForm) {
          return hasConsentForm;
        }
        return hasConsentForm || hasConsentID;
      case 2:
        return (hasIcFrontID && hasIcBackID) || (hasIcFront && hasIcBackID) || (hasIcFrontID && hasIcBack) || (hasIcFront && hasIcBack);
      case 3:
        if (checkID) {
          return hasIncomeID;
        }
        if (checkForm) {
          return hasIncome && !this.checkStringify(income, this.state.oriIncome);
        }
        return hasIncome || hasIncomeID;
      default:
        if (defaultCheck !== null) {
          return defaultCheck;
        }
    }
    return true;
  }
  checkStringify = (source, target) => JSON.stringify(source) === JSON.stringify(target)
  async creditCheckToken() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/customers/${this.props.customerID}/credit_reports/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const reportToken = res.headers.get('X-Csrf-Token');
      const json = await res.json();
      if (json) {
        const newCreditCheckReport = Object.assign({}, json[0] || {});
        await this.setComponentState({ reportToken, creditCheckReportData: newCreditCheckReport }, () => {
          this.generateCreditCheck(newCreditCheckReport);
        });
      }
    }
  }
  async fetchBooking() {
    await this.setLoading(true);
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    const json = await res.json();
    if (json) {
      const newBookingData = Object.assign({}, json || {});
      this.setState({ bookingData: newBookingData });
    }
    await this.setLoading(false);
  }
  async fetchBookingCustomer() {
    await this.setLoading(true);
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/customers/${this.props.customerID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    const json = await res.json();
    if (json) {
      const newData = Object.assign({}, json || {});
      this.setState({ data: newData });
    }
    await this.setLoading(false);
  }
  async fetchCustomerCreditReport() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/customers/${this.props.customerID}/credit_reports/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    const json = await res.json();
    if (json) {
      const newCreditCheckReport = Object.assign({}, json[0] || {});
      this.setState({ creditCheckReportData: newCreditCheckReport });
    }
    await this.setLoading(false);
  }
  async fetchCustomer() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/customers/${this.props.customerID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      if (data.customerCreditReport && data.customerCreditReport !== null) {
        const customerCreditReport = data.customerCreditReport;
        await this.setComponentState({
          customerCreditReport,
        });
      }
    }
  }
  async generateCreditCheck(creditCheckReportData) {
    const { store } = this.context;
    await this.setLoading(true);

    try {
      const jwtToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
      await store.dispatch(fetchM(`/customers/${this.props.customerID}/credit_reports/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.reportToken,
          'X-JWT-Token': jwtToken,
        },
        body: JSON.stringify(creditCheckReportData),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    await this.setLoading(false);
    if (!this.props.pathCheck) {
      store.dispatch(push(`/customers/${this.props.customerID}/`));
    } else {
      store.dispatch(push(`/bookings/${this.props.bookingID}/`));
    }
    store.dispatch(flashSuccessMessage({ header: 'Credit score generating', message: `${this.state.customerDetail.name}'s credit report sent` }));
  }
  async submitIncome(validations, income) {
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
      return;
    }
    await this.setLoading(true);
    const { customerID } = this.props;
    let res;
    try {
      res = await this.form.submit(`/customers/${customerID}/income/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.incomeToken,
        },
        body: JSON.stringify(income),
      });
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    await this.setState({ income: res }, () => {
    });
    await this.setLoading(false);
    await this.handleHasChange();
    await this.handleNextStep();
    await this.handleRefetch();
  }
  async submitLoanInfo(creditCheckReportData) {
    const { store } = this.context;
    await this.setLoading(true);

    const creditReport = creditCheckReportData;
    if (this.state.bookingData && this.state.bookingData.project && this.state.bookingData.project.id !== '') {
      creditReport.bookingID = this.state.bookingData.id;
      creditReport.projectID = this.state.bookingData.project.id;
      creditReport.projectName = this.state.bookingData.project.name;
    }

    let res = '';
    try {
      const jwtToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
      res = await store.dispatch(
        fetchM(`/customers/${this.props.customerID}/credit_reports/`, {
          credentials: 'include',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': this.state.reportToken,
            'X-JWT-Token': jwtToken,
          },
          body: JSON.stringify(creditCheckReportData),
        }),
      );
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    await this.setLoading(false);
    if (res.ok) {
      this.props.onChange(false); // reset changes to allow user to leave current page
      if (!this.props.pathCheck) {
        store.dispatch(push(`/customers/${this.props.customerID}/`));
      } else if (
        this.props.pathCheck &&
        !this.props.location.pathname.includes('customers/')
      ) {
        store.dispatch(push(bookingFlow(this.state.bookingData, 1)));
      } else {
        store.dispatch(
          push(`/bookings/${this.state.bookingData.id}/?section=purchaser`)
        );
      }
      store.dispatch(
        flashSuccessMessage({
          header: 'Credit score generating',
          message: `${this.state.customerDetail.name}'s credit report sent`,
        }),
      );
    }
  }
  async submitPersonalInfo(validations, data) {
    await this.setLoading(true);
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
      await this.setLoading(false);
      return;
    }
    try {
      await this.infoForm.submit(`/customers/${this.props.customerID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.custToken,
        },
        body: JSON.stringify(data),
      });
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage({ err }));
      return;
    }
    await this.setLoading(false);
    await this.handleHasChange();
    await this.handleNextStep();
    await this.handleRefetch();
  }
  async uploadDocument(body, key = 'consent') {
    await this.setLoading(true);
    const { store } = this.context;
    try {
      await store.dispatch(fetchM(`/customers/${this.props.customerID}/documents/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': this.state.documentToken,
        },
        body,
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    if (key === 'ic') {
      await this.icUpload.resetFiles();
    } else {
      await this.consentUpload.resetFiles();
    }
    await this.handleHasChange();
    await this.handleNextStep();
    await this.handleRefetch();
  }
  async updateIncome(validations, income) {
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    let res;
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
      return;
    }
    await this.setLoading(true);
    try {
      res = await this.form.submit(`/customers/${this.props.customerID}/income/${income.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.incomeToken,
        },
        body: JSON.stringify(income),
      });
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    await this.setState({ income: res }, () => {
    });
    await this.setLoading(false);
    await this.handleHasChange();
    await this.handleNextStep();
    await this.handleRefetch();
  }
  handleCheckBox = () => {
    this.setState({
      isAgreedToDSRTerms: !this.state.isAgreedToDSRTerms,
    });
  }
  handleCreateFormData = (type) => {
    let formData = null;
    if (type === 'consent') {
      formData = this.consentUpload.getFormData();
      const { consentForm } = this.state;
      formData.append('files_0', consentForm.file);
      formData.append('tags_0', consentForm.tags);
      formData.append('names_0', consentForm.name);
      formData.append('degrees_0', consentForm.degree);
    } else if (type === 'ic') {
      formData = this.icUpload.getFormData();
      const { icFront, icBack } = this.state;
      if (icFront) {
        formData.append('files_0', icFront.file);
        formData.append('tags_0', icFront.tags);
        formData.append('names_0', icFront.name);
        formData.append('degrees_0', icFront.degree);
        formData.append('mark_0', true);
      }
      if (icBack) {
        formData.append('files_1', icBack.file);
        formData.append('tags_1', icBack.tags);
        formData.append('names_1', icBack.name);
        formData.append('degrees_1', icBack.degree);
        formData.append('mark_0', true);
      }
    }
    return formData;
  }
  handleClickNext = (event) => {
    event.preventDefault();
    if (
      this.checkStepContent(this.state.currentStep, false, true, false)
    ) {
      switch (this.state.currentStep) {
        case 0:
          this.getCustToken(() => {
            this.infoForm.handleSubmit(event);
          });
          break;
        case 1:
          this.getDocumentToken(() => {
            const formData = this.handleCreateFormData('consent');
            this.uploadDocument(formData, 'consent');
          });
          break;
        case 2:
          this.getDocumentToken(() => {
            const formData = this.handleCreateFormData('ic');
            this.uploadDocument(formData, 'ic');
          });
          break;
        case 3:
          this.getIncomeToken(() => {
            this.form.handleSubmit(event);
          });
          break;
        default:
          this.handleNextStep();
      }
    } else {
      this.handleNextStep();
    }
  }
  handleEndStep = async () => {
    await this.getCreditCheckToken(() => {
      this.loanInfo.handleSubmit(event);
    });
  }
  handleGetForm = (consentForm, hasChange = false) => {
    this.setState({ consentForm }, () => {
      this.handleHasChange(hasChange);
    });
  }
  handleGetIC = (ic, direction = 'Front', hasChange = false) => {
    this.setState({ [`ic${direction}`]: ic }, () => {
      this.handleHasChange(hasChange);
    });
  }
  handleHasChange = (hasChange = false) => {
    if (this.props.onChange) {
      this.props.onChange(hasChange);
    }
  }
  handleIncomeChange = (income) => {
    this.setState({ income }, () => {
      this.handleHasChange(true);
    });
  }
  handleLoanChange = (income) => {
    this.setState({ income }, () => {
      this.handleHasChange(true);
    });
  }
  handleNextStep = () => {
    let currentStep = this.state.currentStep + 1;
    if (currentStep > 4) {
      currentStep = 0;
    }
    this.setState({ currentStep });
  }
  handlePersonalInfoChanges = (data) => {
    this.setState({ data }, () => {
      this.handleHasChange(true);
    });
  }
  handlePreviousStep = () => {
    let currentStep = this.state.currentStep - 1;
    if (currentStep <= 0) {
      currentStep = 0;
    }
    this.setState({ currentStep });
  }
  handleRefetch = () => {
    if (this.props.refetch) {
      this.props.refetch();
    }
  }
  renderHeaderContent = () => {
    let { currentStep } = this.state;
    let headerContent = '';
    switch (currentStep) {
      case 0:
        headerContent = 'Personal Details';
        break;
      case 1:
        headerContent = 'CTOS Consent';
        break;
      case 2:
        headerContent = 'Verification';
        break;
      case 3:
        headerContent = 'Financial Info';
        break;
      case 4:
        headerContent = 'Loan Info';
        break;
      default:
        currentStep = 0;
    }
    return headerContent;
  }
  renderStepContent = (currentStep = 0) => {
    const {
      customerCreditReport, data,
      icFrontDocumentID, icFrontDocument,
      icBackDocumentID, icBackDocument, income,
    } = this.state;
    switch (currentStep) {
      case 0: {
        return (
          <PersonalInfo
            ref={(ref) => { this.infoForm = ref; }}
            data={data}
            onSubmit={(validations, d) => {
              this.submitPersonalInfo(validations, d);
            }}
            onChange={this.handlePersonalInfoChanges}
          />
        );
      }
      case 1:
        return (
          <div>
            <UploadForm
              title="NewCreditForm"
              ref={(ref) => { this.consentUpload = ref; }}
              loading={this.props.loading}
              sampleURL="/assets/images/samples/document.svg"
              sampleSize="small"
              auth={this.props.auth}
              tags={['Consent Form']}
              picture={customerCreditReport && customerCreditReport !== null &&
                    customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' &&
                    customerCreditReport.consentDsrDocumentID !== '' &&
                    customerCreditReport.consentDsrDocumentID.length > 0 ?
                customerCreditReport.consentDsrDocument : null}
              onChange={this.handleGetForm}
              downloadURL="https://mhub.my/consent/credit_check/"
              signature
              customerID={this.props.customerID}
              customerName={this.state.customerDetail.name}
              jobTitle={this.state.customerDetail.jobTitle}
              identityTypeID={this.props.identityTypeID}
              identity={this.props.identity}
              onSigned={this.setSignedState}
            />
          </div>
        );
      case 2:
        return (
          <Grid centered>
            <Grid.Row>
              <Grid.Column computer={8} tablet={10} mobile={16}>
                <Header as="h2" content="Upload IC" textAlign="left" />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column computer={6} tablet={8} mobile={16}>
                <UploadForm
                  isCompress
                  title="Front"
                  ref={(ref) => { this.icUpload = ref; }}
                  setLoading={this.setLoading}
                  loading={this.props.loading}
                  sampleURL="/assets/images/samples/ic_front.svg"
                  tags={['IC Front']}
                  picture={icFrontDocumentID && icFrontDocumentID.length > 0 ?
                    icFrontDocument : null}
                  onChange={(ic, hasChange) => this.handleGetIC(ic, 'Front', hasChange)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column computer={6} tablet={8} mobile={16}>
                <UploadForm
                  isCompress
                  title="Back"
                  ref={(ref) => { this.icUpload = ref; }}
                  setLoading={this.setLoading}
                  loading={this.props.loading}
                  sampleURL="/assets/images/samples/ic_back.svg"
                  tags={['IC Back']}
                  picture={icBackDocumentID && icBackDocumentID.length > 0 ?
                    icBackDocument : null}
                  onChange={(ic, hasChange) => this.handleGetIC(ic, 'Back', hasChange)}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        );
      case 3:
        return (
          <Grid centered>
            <Grid.Row>
              <Grid.Column computer={8} tablet={10} mobile={16}>
                <Header as="h2" content="I am" textAlign="left" />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <IncomeForm
                  ref={(ref) => { this.form = ref; }}
                  loading={this.props.loading}
                  customerID={this.props.customerID}
                  onSubmit={(validations, d, docsChanges) => {
                    if (docsChanges) {
                      this.updateIncome(validations, d);
                    } else {
                      this.submitIncome(validations, d);
                    }
                  }}
                  income={income}
                  data={data}
                  onChange={this.handleIncomeChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        );
      default:
        return (
          <Grid centered>
            <Grid.Row>
              <Grid.Column computer={8} tablet={10} mobile={16}>
                <LoanInfo
                  ref={(ref) => { this.loanInfo = ref; }}
                  loading={this.props.loading}
                  onSubmit={(d) => {
                    this.submitLoanInfo(d);
                  }}
                  data={data}
                  onChange={this.handleLoanChange}
                  bookingCustomerData={this.state.bookingData}
                  creditCheckReportData={this.state.creditCheckReportData}
                  pathCheck={this.props.pathCheck}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column computer={8} tablet={10} mobile={16}>
                <Checkbox
                  label="I hereby declare that the purchasers' details furnished are true and correct to the best of my knowledge"
                  onChange={this.handleCheckBox}
                  checked={this.state.isAgreedToDSRTerms}
                  style={{ textAlign: 'left' }}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        );
    }
  }
  renderStep() {
    const { currentStep } = this.state;
    return (
      <Grid centered>
        <Grid.Row style={{ paddingBottom: '0px' }}>
          <Grid.Column computer={4} tablet={5} mobile={8}>
            <Header textAlign="left">
              {this.renderHeaderContent()}
            </Header>
          </Grid.Column>
          <Grid.Column computer={4} tablet={5} mobile={8}>
            <p style={{ textAlign: 'right' }}>{currentStep + 1} of 5</p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column computer={8} tablet={10} mobile={16}>
            <div className="progressBar">
              <Progress
                percent={(currentStep + 1) * 20}
                size="tiny"
              />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            {this.renderStepContent(currentStep)}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <div className="buttonBorder">
              <Container style={{ borderTop: '1px solid rgb(217, 218, 220)', padding: '0.5rem', borderRadius: '0.25rem' }} />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ padding: 0 }}>
          <Grid.Column computer={8} tablet={10} mobile={16}>
            <div className="nextButton">
              <Button
                fluid
                onClick={currentStep === 4 ? this.handleEndStep : this.handleClickNext}
                disabled={this.props.loading || this.checkNextDisabled()}
              >
                {
                  currentStep !== 4 ? 'Next' : null
                }
                {
                  currentStep === 4 && this.props.location.pathname.includes('customers/') ? 'Submit' : null
                }
                {
                  currentStep === 4 && !(this.props.location.pathname.includes('customers/')) ? 'Save and Continue' : null
                }
              </Button>
            </div>
            {
              currentStep > 0 ? (
                <div className="backButton">
                  <Button
                    onClick={this.handlePreviousStep}
                    disabled={this.props.loading}
                    content="< Back"
                  />
                </div>
              ) : null
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  render() {
    const { newHeader } = this.props;
    return (
      <div>
        {this.props.pathCheck &&
          <Header as="h4" textAlign="center">
            Booking for <br className="large-hide small-hide tablet-hide" /><Link to={`/projects/${this.state.bookingData.project && this.state.bookingData.project.id}/units/${this.state.bookingData.projectUnit && this.state.bookingData.projectUnit.id}/`}>{this.state.bookingData.projectUnit && this.state.bookingData.projectUnit.reference}</Link>, {this.state.bookingData.project && this.state.bookingData.project.name} {this.state.bookingData.projectUnit && this.state.bookingData.projectUnit.isBumi && <Label size="mini">Bumi</Label>}
          </Header>
        }
        {newHeader ?
          <Header className="new_title" as="h5" attached="top" textAlign="center">
            {newHeader}
          </Header>
          :
          <Divider
            horizontal
            style={{ color: 'rgba(112, 112, 112, 1)' }}
          >
            {this.props.pathCheck ? 'Customer Assessment' : 'Credit Check'}
          </Divider>
        }
        <Segment className={`stepsContainer ${newHeader ? '' : 'customer'}`} attached={newHeader ? true : false}>
          {this.renderStep()}
        </Segment>
      </div>
    );
  }
}

export default withRouter(NewCreditCheck, { withRef: true });



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/NewCreditCheck.jsx